var _defs, _circle, _path, _path2, _circle2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotonesSvg14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2503.45 1222.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d91111;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        filter: url(#drop-shadow-36);\n      }\n\n      .cls-2, .cls-3, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #a81414;\n      }\n\n      .cls-5 {\n        filter: url(#drop-shadow-35);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-35",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#26130a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-36",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#26130a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 606.33,
    cy: 611.08,
    r: 525.8,
    transform: "translate(-254.51 607.72) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2196.05,341.64H728.6v545.98h1467.45c125.29,0,226.86-101.57,226.86-226.86v-92.26c0-125.29-101.57-226.86-226.86-226.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m2228.57,384.68H802.21v459.89h1426.37c80.26,0,145.55-103.15,145.55-229.94s-65.3-229.94-145.55-229.94Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 606.33,
    cy: 611.08,
    r: 387.04
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1161.36,594.94c-5.43-5.89-8.15-14.2-8.15-24.93v-73.8c0-10.73,2.71-19.04,8.15-24.93,5.43-5.89,13.31-8.83,23.65-8.83s18.22,2.94,23.65,8.83c5.43,5.89,8.15,14.2,8.15,24.93v14.53h-20.41v-15.9c0-8.5-3.6-12.76-10.8-12.76s-10.8,4.25-10.8,12.76v76.75c0,8.38,3.6,12.56,10.8,12.56s10.8-4.19,10.8-12.56v-21h20.41v19.43c0,10.73-2.72,19.04-8.15,24.93-5.43,5.89-13.32,8.83-23.65,8.83s-18.22-2.94-23.65-8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1256.65,594.75c-5.63-6.02-8.44-14.53-8.44-25.52v-72.23c0-10.99,2.81-19.5,8.44-25.52,5.62-6.02,13.74-9.03,24.34-9.03s18.71,3.01,24.34,9.03c5.62,6.02,8.44,14.53,8.44,25.52v72.23c0,10.99-2.82,19.5-8.44,25.52-5.63,6.02-13.74,9.03-24.34,9.03s-18.71-3.01-24.34-9.03Zm35.53-24.14v-74.98c0-9.03-3.73-13.54-11.19-13.54s-11.19,4.51-11.19,13.54v74.98c0,9.03,3.73,13.54,11.19,13.54s11.19-4.51,11.19-13.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1347.93,464.41h27.09l21,82.25h.39v-82.25h19.24v137.4h-22.18l-25.91-100.3h-.39v100.3h-19.24v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1455.69,594.84c-5.37-5.95-8.05-14.49-8.05-25.62v-7.85h20.41v9.42c0,8.9,3.73,13.35,11.19,13.35,3.66,0,6.44-1.08,8.34-3.24,1.9-2.16,2.85-5.66,2.85-10.5,0-5.76-1.31-10.83-3.93-15.21-2.62-4.38-7.46-9.65-14.53-15.8-8.9-7.85-15.11-14.95-18.65-21.3-3.53-6.35-5.3-13.51-5.3-21.49,0-10.86,2.75-19.27,8.24-25.22,5.5-5.95,13.48-8.93,23.95-8.93s18.16,2.98,23.46,8.93c5.3,5.96,7.95,14.5,7.95,25.62v5.69h-20.41v-7.07c0-4.71-.92-8.15-2.75-10.31-1.83-2.16-4.51-3.24-8.05-3.24-7.2,0-10.8,4.39-10.8,13.15,0,4.97,1.34,9.62,4.02,13.94,2.68,4.32,7.56,9.55,14.62,15.7,9.03,7.85,15.24,14.99,18.65,21.4,3.4,6.41,5.1,13.94,5.1,22.57,0,11.26-2.78,19.89-8.34,25.91-5.56,6.02-13.64,9.03-24.24,9.03s-18.39-2.98-23.75-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1551.48,594.84c-5.5-5.95-8.24-14.49-8.24-25.62v-104.82h21.59v106.39c0,4.71.95,8.12,2.85,10.21,1.9,2.09,4.61,3.14,8.15,3.14s6.25-1.05,8.15-3.14c1.9-2.09,2.85-5.5,2.85-10.21v-106.39h20.81v104.82c0,11.12-2.75,19.66-8.24,25.62-5.5,5.96-13.48,8.93-23.95,8.93s-18.45-2.98-23.95-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1642.55,464.41h21.59v117.77h35.53v19.63h-57.12v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1731.28,484.04h-22.57v-19.63h66.74v19.63h-22.57v117.77h-21.59v-117.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1813.13,464.41h29.25l22.38,137.4h-21.59l-3.93-27.28v.39h-24.54l-3.93,26.89h-20.02l22.38-137.4Zm23.55,91.86l-9.62-67.92h-.39l-9.42,67.92h19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1945.82,464.41h32.98c10.73,0,18.78,2.88,24.14,8.64,5.36,5.76,8.05,14.2,8.05,25.32v69.49c0,11.12-2.68,19.56-8.05,25.32-5.37,5.76-13.42,8.64-24.14,8.64h-32.98v-137.4Zm32.58,117.77c3.53,0,6.25-1.05,8.15-3.14,1.9-2.09,2.85-5.5,2.85-10.21v-71.45c0-4.71-.95-8.11-2.85-10.21-1.9-2.09-4.61-3.14-8.15-3.14h-10.99v98.14h10.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2045.14,464.41h58.89v19.63h-37.29v36.31h29.64v19.63h-29.64v42.2h37.29v19.63h-58.89v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1102.77,766.6c-5.37-5.95-8.05-14.49-8.05-25.62v-7.85h20.41v9.42c0,8.9,3.73,13.35,11.19,13.35,3.66,0,6.44-1.08,8.34-3.24,1.9-2.16,2.85-5.66,2.85-10.5,0-5.76-1.31-10.83-3.93-15.21-2.62-4.38-7.46-9.65-14.53-15.8-8.9-7.85-15.11-14.95-18.65-21.3-3.53-6.35-5.3-13.51-5.3-21.49,0-10.86,2.75-19.27,8.24-25.22,5.5-5.95,13.48-8.93,23.95-8.93s18.16,2.98,23.46,8.93c5.3,5.96,7.95,14.5,7.95,25.62v5.69h-20.41v-7.07c0-4.71-.92-8.15-2.75-10.31-1.83-2.16-4.51-3.24-8.05-3.24-7.2,0-10.8,4.39-10.8,13.15,0,4.97,1.34,9.62,4.02,13.94,2.68,4.32,7.56,9.55,14.62,15.7,9.03,7.85,15.24,14.99,18.65,21.4,3.4,6.41,5.1,13.94,5.1,22.57,0,11.26-2.78,19.89-8.34,25.91-5.56,6.02-13.64,9.03-24.24,9.03s-18.39-2.98-23.75-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1191.1,636.16h58.89v19.63h-37.29v36.31h29.64v19.63h-29.64v42.2h37.29v19.63h-58.89v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1288.65,766.6c-5.5-5.95-8.24-14.49-8.24-25.62v-72.23c0-11.12,2.75-19.66,8.24-25.62,5.5-5.95,13.48-8.93,23.95-8.93s18.45,2.98,23.95,8.93c5.5,5.96,8.24,14.5,8.24,25.62v11.78h-20.41v-13.15c0-9.03-3.73-13.54-11.19-13.54s-11.19,4.51-11.19,13.54v75.18c0,8.9,3.73,13.35,11.19,13.35s11.19-4.45,11.19-13.35v-26.89h-10.8v-19.63h31.21v44.95c0,11.12-2.75,19.66-8.24,25.62-5.5,5.96-13.48,8.93-23.95,8.93s-18.45-2.98-23.95-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1385.81,766.6c-5.5-5.95-8.24-14.49-8.24-25.62v-104.82h21.59v106.39c0,4.71.95,8.12,2.85,10.21,1.9,2.09,4.61,3.14,8.15,3.14s6.25-1.05,8.15-3.14c1.9-2.09,2.85-5.5,2.85-10.21v-106.39h20.81v104.82c0,11.12-2.75,19.66-8.24,25.62-5.5,5.96-13.48,8.93-23.95,8.93s-18.45-2.98-23.95-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1476.89,636.16h21.59v137.4h-21.59v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1534.2,636.16h30.82l13.74,98.34h.39l13.74-98.34h30.82v137.4h-20.41v-104.03h-.39l-15.7,104.03h-18.06l-15.7-104.03h-.39v104.03h-18.84v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1659.43,636.16h21.59v137.4h-21.59v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1716.75,636.16h58.89v19.63h-37.29v36.31h29.64v19.63h-29.64v42.2h37.29v19.63h-58.89v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1807.63,636.16h27.09l21,82.25h.39v-82.25h19.24v137.4h-22.18l-25.91-100.3h-.39v100.3h-19.24v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1927.95,655.79h-22.57v-19.63h66.74v19.63h-22.57v117.77h-21.59v-117.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2008.23,766.5c-5.63-6.02-8.44-14.53-8.44-25.52v-72.23c0-10.99,2.81-19.5,8.44-25.52,5.62-6.02,13.74-9.03,24.34-9.03s18.71,3.01,24.34,9.03c5.62,6.02,8.44,14.53,8.44,25.52v72.23c0,10.99-2.82,19.5-8.44,25.52-5.63,6.02-13.74,9.03-24.34,9.03s-18.71-3.01-24.34-9.03Zm35.53-24.14v-74.98c0-9.03-3.73-13.54-11.19-13.54s-11.19,4.51-11.19,13.54v74.98c0,9.03,3.73,13.54,11.19,13.54s11.19-4.51,11.19-13.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2103.82,766.6c-5.37-5.95-8.05-14.49-8.05-25.62v-7.85h20.41v9.42c0,8.9,3.73,13.35,11.19,13.35,3.66,0,6.44-1.08,8.34-3.24,1.9-2.16,2.85-5.66,2.85-10.5,0-5.76-1.31-10.83-3.93-15.21-2.62-4.38-7.46-9.65-14.53-15.8-8.9-7.85-15.11-14.95-18.65-21.3-3.53-6.35-5.3-13.51-5.3-21.49,0-10.86,2.75-19.27,8.24-25.22,5.5-5.95,13.48-8.93,23.95-8.93s18.16,2.98,23.46,8.93c5.3,5.96,7.95,14.5,7.95,25.62v5.69h-20.41v-7.07c0-4.71-.92-8.15-2.75-10.31-1.83-2.16-4.51-3.24-8.05-3.24-7.2,0-10.8,4.39-10.8,13.15,0,4.97,1.34,9.62,4.02,13.94,2.68,4.32,7.56,9.55,14.62,15.7,9.03,7.85,15.24,14.99,18.65,21.4,3.4,6.41,5.1,13.94,5.1,22.57,0,11.26-2.78,19.89-8.34,25.91-5.56,6.02-13.64,9.03-24.24,9.03s-18.39-2.98-23.75-8.93Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m698,668.48c51.98-70.92,36.61-170.55-34.31-222.53-70.92-51.98-170.55-36.61-222.53,34.31-51.98,70.92-36.61,170.55,34.31,222.53,56.06,41.08,132.28,41.05,188.31-.07h-.02c.73.98,1.52,1.91,2.4,2.82l94.3,94.3c9.56,9.57,25.08,9.58,34.65.01s9.58-25.08.01-34.65l-94.3-94.3c-.88-.89-1.82-1.71-2.82-2.45v.02Zm6.32-94.16c0,74.4-60.32,134.72-134.72,134.72s-134.72-60.32-134.72-134.72,60.32-134.72,134.72-134.72,134.72,60.32,134.72,134.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotonesSvg14);
export default __webpack_public_path__ + "static/media/BOTONES_SVG 14.efac543b3428adf3ef9365fe557e937e.svg";
export { ForwardRef as ReactComponent };